import React, { useState, useEffect } from "react";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Label,
  Input,
  Button,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { NavLink, useNavigate,useLocation } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { useParams } from "react-router-dom";
import { requestApi } from "../../../request-api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Triangle } from "react-loader-spinner";

function ApproverCompiledViews() {
  let [calendarValue, setCalenderValue] = useState(new Date());
  let [showCalender, setShowCalender] = useState(false);
  let [selectedDate, setSelectedDate] = useState("");
  let [filter, setFilter] = useState("");
  const [dateOfComplaince, setDateOfComplaince] = useState(true);
  const [reason, setReason] = useState(false);
  const [criticality, setCriticality] = useState(false);
  const [commentOfOfficer, setCommentOfOfficer] = useState(true);
  const [dueDateOfCompletion, setDueDateOfCompletion] = useState(true);
  let [compliance, setCompliance] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  let [complianceName, setComplianceName] = useState([]);
  let { reportId, legislationId, complianceId } = useParams();

  let [dateOfComplaince2, setDateOfComplaince2] = useState();
  let [status, setStatus] = useState("");
  let [uploadProofOfFile, setUploadProofOfFile] = useState("");
  let [reason2, setReason2] = useState("");
  let [criticality2, setCriticality2] = useState("");
  let [commentOfOfficer2, setCommentOfOfficer2] = useState("");
  let [dueDateOfCompletion2, setDueDateOfCompletion2] = useState();
  let [description, setDescription] = useState("");
  let [loading, setLoading] = useState(false);
  let [formValues, setFormValues] = useState(false);
  const location = useLocation();
  const successToast = (message) =>
    toast.success(message, {
      position: "bottom-right",
    });

  const errorToast = (error) =>
    toast.error(error, {
      position: "bottom-right",
    });

  let count = 0;
  const getData = () => {
    console.log("------>");
    setLoading(true);
    requestApi(
      `/compliancer/getCompliancerByLegislation/${reportId}/${legislationId}/${complianceId}`,
      {
        method: "get",
      }
    )
      .then((data) => {
        setLoading(false);
        console.log("first", data.data);
        setCompliance(data.data);
        setStatus(data.data.current_compliance_status);
        var diff = Math.abs(new Date(data.data.due_date) - 1);
        console.log("due date",new Date(diff));
        setDueDateOfCompletion2(new Date(diff));
        console.log("due date",new Date(data.data.due_date));
        // setDueDateOfCompletion2(data.data.due_date);
        setReason2(data.data.reason);
        setUploadProofOfFile(data.data.proofs_link);
        setCriticality2(data.data.criticality);
        setCommentOfOfficer2(data.data.comment_of_officer);
        setDescription(data.data.description);
        console.log("-----<><><>", new Date(data.data.due_date));
      })
      .catch((error) => {
        setLoading(false);
        errorToast(error.message);
        console.log(error);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  // bhushan code

  const initialFormValues = { filterselect: "" };

  let [formErrors, setFormErrors] = useState({});

  const validateBanner = async (e) => {
    e.preventDefault();
    const validate = await formValidation();
    setFormErrors(validate);
    console.log("------>", validate);
    console.log("validate", validate);
    if (Object.keys(validate).length == 0) {
      submitHandler(e);
    }
  };

  const formValidation = () => {
    const errors = {};
    console.log("first=====M", status, uploadProofOfFile, criticality2);

    if (status == "" || status == 'select'|| status == null) {
      errors.status = "Status is required";
    } else if (status == "Complied") {
      if (uploadProofOfFile == "" || uploadProofOfFile == null) {
        errors.uploadProofOfFile = "upload of ProofOfFile is required";
      }
      if (commentOfOfficer2 == "" || commentOfOfficer2 == null) {
        console.log("first");
        errors.commentOfOfficer = "Comment Of  Officer is required";
      }
      if (description == "" || description == null) {
        errors.description = "Description is required";
      }
    } else if (status == "Not Complied") {
      if (uploadProofOfFile == "" || uploadProofOfFile == null) {
        errors.uploadProofOfFile = "upload of ProofOfFile is required";
      }
      if (commentOfOfficer2 == "" || commentOfOfficer2 == null) {
        errors.commentOfOfficer = "Comment Of  Officer is required";
      }
      if (description == "" || description == null) {
        errors.description = "Description is required";
      }
      if (reason2 == "" || reason2 == null) {
        errors.reason = "Description is required";
      }
      if (criticality2 == "" || criticality2 == null) {
        errors.criticality = "Criticality is required";
      } else if (criticality2 == "Select Criticality") {
        errors.criticality = "Criticality is required";
      }
    } else if (status == "Not applicable") {
      if (uploadProofOfFile == "" || uploadProofOfFile == null) {
        errors.uploadProofOfFile = "upload of ProofOfFile is required";
      }

      if (description == "" || description == null) {
        errors.description = "Description is required";
      }
    } else if (status == "Complied with exception") {
      if (uploadProofOfFile == "" || uploadProofOfFile == null) {
        errors.uploadProofOfFile = "upload of ProofOfFile is required";
      }
      if (description == "" || description == null) {
        errors.description = "Description is required";
      }
      if (reason2 == "" || reason2 == null) {
        errors.reason = "Description is required";
      }
      if (criticality2 == "" || criticality2 == null) {
        errors.criticality = "Criticality is required";
      }
    }

    return errors;
  };
  const options = [
    {
      label: "Complied",
      value: "Complied",
    },
    {
      label: "Not Complied",
      value: "Not Complied",
    },
    {
      label: "Not applicable",
      value: "Not applicable",
    },
    {
      label: "Complied with exception",
      value: "Complied with exception",
    },
  ];

  const filer = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    // console.log(e.target.value)

    if (e.target.value == "Complied") {
      console.log("Complied");
      setReason(false);
      setCriticality(false);
      setCommentOfOfficer(true);
      setDueDateOfCompletion(true);
    }

    if (e.target.value == "Not Complied") {
      setReason(true);
      setCriticality(true);
      setDueDateOfCompletion(true);
      setCommentOfOfficer(true);
    }

    if (e.target.value == "Not applicable") {
      console.log("Not applicable");
      setCommentOfOfficer(false);
      setDueDateOfCompletion(false);
      setReason(false);
      setCriticality(false);
    }

    if (e.target.value == "Complied with exception") {
      console.log("Compiled With Exception");
      setCommentOfOfficer(false);
      setDueDateOfCompletion(true);
      setReason(true);
      setCriticality(true);
    }
  };
  const filerWhileLoad = () => {
    // console.log(e.target.value)

    if (status == "Complied") {
      console.log("Complied");
      setReason(false);
      setCriticality(false);
      setCommentOfOfficer(true);
      setDueDateOfCompletion(true);
    }

    if (status == "Not Complied") {
      setReason(true);
      setCriticality(true);
      setDueDateOfCompletion(true);
      setCommentOfOfficer(true);
    }

    if (status == "Not applicable") {
      console.log("Not applicable");
      setCommentOfOfficer(false);
      setDueDateOfCompletion(false);
      setReason(false);
      setCriticality(false);
    }

    if (status == "Complied with exception") {
      console.log("Compiled With Exception");
      setCommentOfOfficer(false);
      setDueDateOfCompletion(true);
      setReason(true);
      setCriticality(true);
    }
  };
  useEffect(() => {
    filerWhileLoad();
  }, [status]);
  const statusHandler = (e) => {
    filer(e);
    setStatus(e.target.value);
  };
  useEffect(() => {
    setSelectedDate(
      `${calendarValue.getDate()}/${
        calendarValue.getMonth() + 1
      }/${calendarValue.getFullYear()}`
    );
  }, [calendarValue]);

  let navigate = useNavigate();

  const validate = () => {};

  const submitHandler = () => {
    setLoading(true);
    requestApi(`/auditor/updateCompliance/${complianceId}`, {
      method: "put",
      body: JSON.stringify({
        due_date: dueDateOfCompletion2,
        updated_on: startDate,
        comment_of_officer: commentOfOfficer2,
        description: description,
        proof_mandatory: uploadProofOfFile,
        current_compliance_status: status,
        reason: reason2,
        description: description,
        criticality: criticality2,
      }),
    })
      .then((data) => {
        setLoading(false);
        if (data.statusCode === 200) {
          successToast("Successfully submit current compliance");

          navigate(
            `${directUrl}auditor/legislation-list/${reportId}/${legislationId}`
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        errorToast(error.message);
        console.log(error);
      });
  };

  return (
    <section className="lyt-section">
      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      ) : null}
      <Container fluid className="typ-container">
           <Breadcrumb className="bs-breadcrumb mt-0">
        <BreadcrumbItem><NavLink to={`${directUrl}approver/reports-approver`}>Reports</NavLink></BreadcrumbItem>
        <BreadcrumbItem>
        
        <NavLink
              onClick={(e) => {
                e.preventDefault();
                navigate(`${directUrl}approver/view/legislation-list/${location.state.row.id}`, {
                  state: {
                    leg: location.state.leg,
                    row: location.state.row,
                  },
                });
              }}
            >
              {location.state.row.report_id}
            </NavLink>
        </BreadcrumbItem>
          <BreadcrumbItem>
          <BreadcrumbItem><NavLink
            onClick={(e) => {
              e.preventDefault();
              navigate(`${directUrl}approver/view/legislation-list/${location.state.row.id}/${location.state.leg.id}`, {
                state: {
                  leg: location.state.leg,
                  row: location.state.row,
                },
              });
            }}
          >{location.state.leg.legislation_name}
          </NavLink>
          </BreadcrumbItem>
          </BreadcrumbItem>
          <BreadcrumbItem active>{location.state.compliance.compliance}</BreadcrumbItem>
        </Breadcrumb>
        <div className="bs-card px-0">
          <div className="padding-area">
            <h1 className="bs-heading typ-rule">
              Procedure for nomination{" "}
              <span className="rule">{compliance.provision}</span>
            </h1>
            <p className="bs-para typ-desc">
              <span className="bold">Compliance Description :</span>{" "}
              {compliance.compliance_description}
            </p>
            <p className="bs-para">
              <span className="bold">Penalty Type :</span>{" "}
              {compliance.penalty_type}
            </p>
            <p className="bs-para">
              <span className="bold">Penalty Description :</span>{" "}
              {compliance.penalty_description}
            </p>
          </div>
          <div className="mod-divider"></div>
          <div className="padding-area">
            <form className="bs-form">
              <Row>
                {dateOfComplaince ? (
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="doj" className="mr-sm-2 cstm-label">
                      Date of Compliance
                    </Label>
                    <div className="calender-area">
                      <DatePicker
                      disabled
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholderText="Enter Date of Joining"
                      />
                    </div>
                  </Col>
                ) : null}
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="status" className="mr-sm-2 cstm-label">
                    Status
                  </Label>
                  <div className="select-option">
                    <Input
                    disabled
                      className="typ-select mb"
                      type="select"
                      onChange={(e) => {
                        statusHandler(e);
                      }}
                      name="filterselect"
                      id="exampleSelect"
                      value={status}
                    ><option value={'select'}>Select</option>
                      {options.map((option) => (
                        <option  selected={option.value == status ? true : false}   value={option.value}>{option.label}</option>
                      ))}
                      {/* <option value={0}>Compiled</option>
                                            <option value={1}>Not Compiled</option>
                                            <option value={2}>Not Applicable</option>
                                            <option value={3}>Compiled With Exception</option> */}
                      {/* <option>Not Compiled</option>
                                        <option>Not Applicable</option>
                                        <option>Compiled With Exception</option> */}
                    </Input>
                    <p className="error-message">{formErrors.status}</p>
                  </div>
                </Col>
                {dueDateOfCompletion ? (
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="doj" className="mr-sm-2 cstm-label">
                      Due Date of Completion 
                    </Label>
                    <div className="calender-area">
                    <DatePicker
                    disabled
                         dateFormat={'yyyy-MM-dd'}
                         selected={dueDateOfCompletion2}
                        onChange={(date) => setDueDateOfCompletion2(date)}
                        placeholderText="Enter Due Date of Completion"
                      />
                    </div>
                  </Col>
                ) : null}
                {reason ? (
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="exampleText" className="cstm-label">
                      Reason
                    </Label>
                    <Input
                    disabled
                      type="textarea"
                      name="text"
                      className="cstm-input"
                      value={reason2}
                      onChange={(e) => setReason2(e.target.value)}
                      rows="5"
                      id="exampleText"
                      placeholder="Type Here..."
                    />
                    <p className="error-message">{formErrors.reason}</p>
                  </Col>
                ) : null}
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="exampleEmail" className="mr-sm-2 cstm-label">
                    Upload Proof of File
                  </Label>
                  <div className="position-relative">
                    
                    <InputGroup>
                      <Input disabled placeholder={uploadProofOfFile} className="mb-0" />
                      <InputGroupText>Proof File</InputGroupText>
                    </InputGroup>
                  </div>
                </Col>
                {criticality ? (
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="status" className="mr-sm-2 cstm-label">
                      Criticality
                    </Label>
                    <div className="select-option">
                      <Input
                      disabled
                        className="typ-select mb"
                        type="select"
                        value={criticality2}
                        onChange={(e) => {
                          setCriticality2(e.target.value);
                        }}
                        name="select"
                        id="exampleSelect"
                      >
                        <option>Select Criticality</option>
                        <option value={"High"}>High</option>
                        <option value={"Medium"}>Medium</option>
                        <option value={"Low"}>Low</option>
                      </Input>
                      <p className="error-message">{formErrors.criticality}</p>
                    </div>
                  </Col>
                ) : null}
                {commentOfOfficer ? (
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <Label for="exampleText" className="cstm-label">
                      Comment of Officer
                    </Label>
                    <Input
                    disabled
                      type="textarea"
                      name="text"
                      value={commentOfOfficer2}
                      onChange={(e) => {
                        setCommentOfOfficer2(e.target.value);
                      }}
                      className="cstm-input"
                      rows="5"
                      id="exampleText"
                      placeholder="Type Here..."
                    />
                    <p className="error-message">
                      {formErrors.commentOfOfficer}
                    </p>
                  </Col>
                ) : null}
                <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                  <Label for="exampleText" className="cstm-label">
                    Description
                  </Label>
                  <Input
                  disabled
                    type="textarea"
                    name="text"
                    className="cstm-input"
                    rows="5"
                    value={description}
                    onChange={(e) => {
                      setDescription(e.target.value);
                    }}
                    id="exampleText"
                    placeholder="Type Here..."
                  />
                  <p className="error-message">{formErrors.description}</p>
                </Col>
              
              </Row>
            </form>
          </div>
        </div>
        <ToastContainer />
      </Container>
    </section>
  );
}

export default ApproverCompiledViews; 
